<template>
	<vx-card title="الاختبارات">
		<div id="div-with-loading" class="vs-con-loading__container">
			<vs-table max-items="10"  :data="data">
				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between" >
					<div class="flex flex-wrap-reverse items-center data-list-btn-container">
					</div>
				</div>

				<template slot="thead">
					<vs-th>الفقرة</vs-th>
					<vs-th>سرعة القراءة</vs-th>
					<vs-th>درجة الاستيعاب</vs-th>
					<vs-th>المستوى</vs-th>
					<vs-th>الموضوع</vs-th>
					<vs-th>التاريخ</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td :data="data[indextr].id">
							{{ data[indextr].paragraph.title }}
						</vs-td>
						<vs-td :data="data[indextr].id">
							{{ data[indextr].reading_speed }}
						</vs-td>
						<vs-td :data="data[indextr].id">
							{{ data[indextr].understanding_grade }}
						</vs-td>
                        <vs-td :data="data[indextr].id">
							{{ data[indextr].paragraph.level.name }}
						</vs-td>
                        <vs-td :data="data[indextr].id">
							{{ data[indextr].paragraph.topic.name }}
						</vs-td>
                        <vs-td :data="data[indextr].id">
							{{ data[indextr].created_at }}
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</div>
		<vs-pagination :total="totalPages" v-model="currentPage" />

	</vx-card>
</template>

<script>

const initObject = {
	id: -1,
	username: '',
	first_name: '',
	last_name: '',
	password: '',
	confirm_password: '',
	email: ''
};
export default {
	data() {
		return {
			deleteItemId: -1,
			deletePrompt: false,
			activePrompt: false,
			data: [],
			oldDataObject: {...initObject},
			page: 1,
			totalPages: 1
		};
	},
	methods: {
		showExams(idx){

		},
		addNewItem(){
		    this.oldDataObject = {...initObject};
			this.activePrompt = true;
		},
		editData(idx){
			this.oldDataObject = Object.assign({} , this.data[idx]);
			this.activePrompt = true;
		},
		openConfirm(id){
			this.deleteItemId = id;
			this.deletePrompt = true;
		},
		updateStatus(event) {
			if(event.isNew === true){
				  this.data.push(event.data);
			}else{
				let roleIdx = this.data.findIndex(e => e.id === event.data.id);
				this.$set(this.data, roleIdx, event.data);
			}
			this.activePrompt = false;
		},
		closeModel(){
			this.activePrompt = false;
		},
		close() {
			this.deletePrompt = false;
		},
		getData(page) {
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 0.6
			});
			axios.get("/user-test/"+ this.$route.params.id +"?page=" + page).then(response => {
				this.data = response.data.data.data;
				this.totalPages = response.data.data.last_page;
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			});
		},
		deleteRequest(){
			this.$vs.loading({
				container: "#div-with-loading",
				scale: 0.6
			});
			axios.delete('/students/' + this.data[this.deleteItemId].id)
			.then(res => {
				if(res.status === 200){
					this.data.splice(this.deleteItemId, 1);
					this.$vs.notify({
							title: "تم الحذف بنجاح",
							text: "تم حذف التسجيلة بنجاح",
							color: "success",
							position: "top-left"
						});
				}
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			}).catch(e => {
				this.$vs.loading.close("#div-with-loading > .con-vs-loading");
			});
		},

	},
	mounted() {
		// this.getData(this.page);
	},
	computed: {
		currentPage: {
			get() {
				return this.page;
			},
			set(val) {
				this.page = val;
				this.getData(this.page);
			}
		}
	}
};
</script>

<style scoped>
#action {
	margin-left: 200px;
}
</style>
